import React, { useState, useEffect } from 'react'
import { Drawer } from 'antd'
import Select from 'react-select'
import { useHistory, useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'

import { normalize, patientName, useListData, useToggle } from '../../modules'

const PatientRequest = ({ patients = [], path, onPerform }) => {
    // let group = 'Non-Medical Billed Items'

    // let { categories } = groups.find(grp => grp.name === group) ?? { categories: [] }
    
    const { index } = useParams()

    const [selected, setSelected] = useState(patients[index]?.items ?? [])
    const [string, setString] = useState()

    const history = useHistory()

    const { user } = useSelector(state => state.application)

    const [visible, toggleVisible] = useToggle(true)
    const [select] = useToggle()

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    useEffect(() => {
        if (patients[index]?.items?.length === undefined)
            close()
    }, [])

    const [
        { loading, fetch: fetchItems },
        { list: items },
        { page = 1, limit = 10 }
    ] = useListData('saleItems', { routingGroup: 'Pharmacy', string }, { notify: true }, 'items')

    const search = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            fetchItems()
        }  
    }

    const modifyQty = (i, val) => {
        let temp = [...selected]
        temp[i].quantity += val

        if (temp[i].quantity <= 0)
            temp = temp.filter((_, k) => k !== i)

        setSelected(temp)
    }

    const save = () => {
        onPerform(selected, index)
        setTimeout(close, 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ save } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Request</button>
                    <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width={600}>
            <p className="font-extrabold text-3xl mb-0">{ patientName(patients[index]?.name) }'s Request</p>
            <div className="w-full my-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Request Items
                </label>
                <Select
                    isMulti
                    onInputChange={ search }
                    onChange={ setSelected }
                    value={ selected }
                    isLoading={ loading }
                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                    styles={{
                        option: (styles, { data }) => { 
                            let { current } = data
                            return {
                                ...styles, 
                                backgroundColor: current <= 0 ? undefined : styles.backgroundColor,
                                color: current <= 0 ? 'gray' : styles.color,
                                cursor: current <= 0 ? 'not-allowed' : 'default'
                            }
                        }
                    }}
                    options={ items?.map(itm => ({ label: `${itm.name}${itm.current <= 0 ? ` - Ksh. ${itm.price} (Out of Stock)` : '' }`, value: itm._id, item: itm._id, ...itm, quantity: 1, isDisabled: itm?.current <= 0 })) }
                    placeholder={ `What items is ${patientName(patients[index]?.name)} being sent for?` } />
            </div>
            <div className="p-3 mt-4 h-full">
                {
                    selected.length > 0 ?
                        <div className="overflow-x-auto">
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Item</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Quantity</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Unit Price</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Total</div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        selected.map((item, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ item.name }</div>
                                                </td>
                                                <td className="p-2 flex items-center justify-center">
                                                    <button onClick={() => modifyQty(key, -1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">-</button>
                                                    <span className="text-center px-3">{ item.quantity }</span>
                                                    <button onClick={() => modifyQty(key, 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">+</button>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">Ksh. { item.price }</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">Ksh. { item.price * item.quantity }</div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            <div className="flex flex-col items-end mb-3 p-3">
                                <p className="font-semibold text-lg underline mb-2">Total Selected</p>
                                <p>Total: Ksh. { normalize(selected.reduce((total, itm) => total + (itm.price * itm.quantity), 0)) }</p>
                            </div>
                        </div>
                        :
                        <div className="w-full h-16 mt-4 flex items-center justify-center">
                            <p className="font-semibold text-base">You can add items by selecting from the list above</p>
                        </div>
                }
            </div>
        </Drawer>
    )
}

export default PatientRequest